var Alert = {
  Wrapper: {
    styles: {
      base: {
        paddingY: 'major-2'
      }
    }
  },
  defaultProps: {
    accent: true,
    variant: 'bordered'
  }
};

export default Alert;
